import api from "@/plugins/api";
/** Service responsible for export-related API calls */
export class ExportService {
    /**
     * Request a report generation.
     * Note: The backend should return a 200 status code.
     */
    static async exportReport(params) {
        try {
            const res = await api.post("/export", params);
            return res.status >= 200 && res.status < 300;
        }
        catch (e) {
            return false;
        }
    }
}
export default ExportService;
